module.exports = __webpack_public_path__ + "static/media/HTMLimage.2d2a1016.png";